import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { EmailValidator } from '../../../utils/email-validator';
import { ShareService, InspectionService, PeopleService } from '../../services/index';
import { InformationComponent } from '../../../modal/information.component';
import { Inspection } from '../../models/index';
import * as _ from 'lodash';
import { ApplicationType } from '../../../utils';
import { switchMap } from 'rxjs/operators';

@Component({
    templateUrl: './report-pdf-share.component.html',
    standalone: false
})
export class ReportPdfSharePageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  editForm: UntypedFormGroup;
  public inspectionId: string;
  public reportId: string;
  public processing = false;
  public copy = false;
  public fullReport = false;
  public fullReportWithoutPrices = false;
  public from = 'myreportmaintenance.bsa@bobst.com';
  @ViewChild('sentInformation', { static: true }) sentInformation: InformationComponent;

  constructor(
    public inspectionService: InspectionService,
    location: Location,
    private shareService: ShareService,
    private activatedRoute: ActivatedRoute,
    private peopleService: PeopleService,
    private router: Router,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['itemId'];
      if (id == null) this.cancel();

      const reportId = params['reportId'];
      this.reportId = reportId;
      this.inspectionId = id;
      this.initData();
    });
  }

  public cancel() {
    this.goToBack();
  }

  updateCopy() {
    this.copy = !this.copy;
  }

  updateFullReport() {
    this.fullReport = !this.fullReport;
  }

  updateFullReportWithoutPrice() {
    this.fullReportWithoutPrices = !this.fullReportWithoutPrices;
  }

  share(model: any): void {
    this.processing = true;
    model.inspectionId = this.inspectionId;
    model.reportId = this.reportId;
    model.copy = this.copy;
    model.fullReport = this.fullReport;
    model.fullReportWithoutPrices = this.fullReportWithoutPrices;
    if (!this.reportId) {
      this.shareService
        .createEmptyShare(model)
        .pipe(
          switchMap((share) =>
            this.inspectionService.createReport(this.inspectionId, this.inspection.inputLanguage.toLowerCase(), share.id)
          )
        )
        .subscribe(() => this.router.navigate([this.inspectionsRoute, this.inspection.id, 'reports']));
      return;
    }
    this.shareService.shareReport(model).subscribe(() => {
      this.processing = false;
      this.openSentInformation();
    });
  }

  public openSentInformation() {
    this.sentInformation.open();
  }

  public closeSentInformation() {
    this.goToBack();
  }

  initForm(shareData: any) {
    this.editForm = new UntypedFormGroup({
      to: new UntypedFormControl('', Validators.compose([EmailValidator.validate])),
      message: new UntypedFormControl(this.shareService.generateMessage(this.inspection, shareData))
    });
  }

  initData(): void {
    this.copy = !this.reportId;
    this.fullReport = !this.reportId;
    this.fullReportWithoutPrices = !this.reportId;
    this.inspectionService.getInspection(this.inspectionId).subscribe((el) => {
      this.inspection = el;
      if (this.inspection.applicationType === ApplicationType.Optimization) {
        this.from = 'myreportoptimization.bsa@bobst.com';
      }

      if (this.reportId) {
        this.shareService.getShareData(this.reportId).subscribe((shareData) => {
          this.initForm(shareData);
          this.cdf.detectChanges();
        });
      } else {
        this.initForm({
          EquipmentType: this.inspection.data.machine.ModelName,
          EquipmentId: this.inspection.data.machine.Serial?.join(', '),
          TechnicianName: this.inspection.technicianName,
          InspectionType: this.inspection.reportType
        });
        this.editForm.get('to').setValue(this.inspection.insptectionInspectionCustomer.Email);
      }
    });
  }

  pressEnter(e: any) {
    if (e.key === 'Enter') {
      this.editForm.get('to').setValue(this.editForm.get('to').value + '; ');
    }
  }

  get isMaitenance() {
    return this.inspection.applicationType === ApplicationType.Maintenance;
  }
}
